// extracted by mini-css-extract-plugin
module.exports = {"SecurityCard":"SecurityCard_SecurityCard__sVoaB","Content":"SecurityCard_Content__s9Avi"};